document.addEventListener("DOMContentLoaded", async function () {
  const photoPreview = document.getElementById("photo-preview");
  const messagePreview = document.getElementById("message-preview");
  const introPagesContainer = document.getElementById("intro-pages");

  const selectedGender = (await loadProfile())?.gender;
  const childName = (await loadProfile())?.name;

  if (!selectedGender || !childName) {
    window.location.replace("/pages/personalise-book");
    return;
  } else {
    document.getElementById("child-name").innerText = `For: ${childName}`;
  }

  const introPages = {
    BOY: [
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Intro_1.png?v=1747811573",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Intro_2.png?v=1747811573",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Intro_3.png?v=1747811573",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Intro_4.png?v=1747811572",
    ],
    GIRL: [
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Intro_1.png?v=1747811573",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Girl_Intro_2.png?v=1747811889",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Intro_3.png?v=1747811573",
      "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Boy_Intro_4.png?v=1747811572",
    ],
  };

  let imageCount = 0;

  function createWrappedIntroImage(src) {
    const wrapper = document.createElement("div");
    wrapper.classList.add("story-page");

    const sideClass =
      imageCount % 2 === 0 ? "story-page-left" : "story-page-right";
    wrapper.classList.add(sideClass);

    const img = document.createElement("img");
    img.src = src;
    img.classList.add("intro-page");
    wrapper.appendChild(img);

    imageCount++;
    return wrapper;
  }

  introPages[selectedGender].forEach((src) => {
    const wrapped = createWrappedIntroImage(src);
    introPagesContainer.appendChild(wrapped);
  });

  // const continueBtn = document.getElementById("continue-to-format-btn");
  // if (continueBtn) {
  //   continueBtn.addEventListener("click", () => {
  //     window.location.href = "/pages/format";
  //   });
  // }
});
